import { useEffect } from "react";
import { IMensagem, ITipoMensagem } from "../../interfaces/IMensagens";
import { Modal } from 'react-bootstrap-v5';
import clsx from "clsx";
import * as Yup from 'yup';
import { useFormik } from 'formik';
import MensagensService from "../../services/MensagensService";
import { IRegras } from "../../interfaces/IRegras";

function MensagensModal({ toggleModal, show, mensagem, regras, tipoMensagens, title }: { toggleModal: (recarregarInformacoes: boolean) => void, show: boolean, mensagem: IMensagem, regras: IRegras[] | undefined, tipoMensagens: ITipoMensagem[] | undefined, title: string }) {

  const mensagemSchema = Yup.object().shape({
    regraID: Yup.number().required('Regra é obrigatório').moreThan(0),
    tipoMensagemID: Yup.number().required('Tipo de Mensagem é obrigatório'),
    descricaoRegraNegocio: Yup.string().max(250, 'Máximo 250 caracteres').required('Descrição da Regra de Negócio é obrigatório'),
    divergencia: Yup.string().max(250, 'Máximo 250 caracteres').required('Divergência é obrigatório'),
    descricaoMensagem: Yup.string().max(250, 'Máximo 250 caracteres').required('Descrição da Mensagem é obrigatório'),
    recomendacaoAjuste: Yup.string().max(250, 'Máximo 250 caracteres').required('Recomendação de Ajuste é obrigatório'),
    simboloID: Yup.number().required('Símbolo é obrigatório').moreThan(0)
  })

  const formInitialValues: IMensagem = {
    id: 0,
    tipoMensagemID: 0,
    regraID: 0,
    descricaoRegraNegocio: '',
    divergencia: '',
    descricaoMensagem: '',
    recomendacaoAjuste: '',
    simboloID: 0
  };

  const formik = useFormik({
    initialValues: formInitialValues,
    validationSchema: mensagemSchema,
    onSubmit: async (mensagem, { setSubmitting }) => {
      function funcaoSucesso() {
        setSubmitting(false);
        toggleModal(true);
      }

      if ((mensagem?.id ?? 0) === 0) {
        await MensagensService.criar(mensagem, funcaoSucesso, 'Mensagem foi adicionada com sucesso');
      } else {
        await MensagensService.atualizar(mensagem, funcaoSucesso, 'Mensagem foi editada com sucesso');
      }
    }
  })

  const listaSimbolos = [
    { id: 1, descricao: 'Confere e correto', icone: 'bi bi-check2' },
    { id: 2, descricao: 'Conferido por documento', icone: 'bi bi-check2-circle' },
    { id: 3, descricao: 'Soma exata', icone: 'fas fa-sigma' },
    { id: 4, descricao: 'Soma aproximada', icone: 'fas fa-sigma-circle' },
  ];

  useEffect(() => {
    formik.resetForm();
    
    if(mensagem?.id > 0){
      formik.setValues(mensagem);
    }

    // eslint-disable-next-line
  }, [mensagem]);

  return <>
    <Modal size='lg' centered={true} show={show} onHide={toggleModal}>
      <div className="modal-content">

        <div className="modal-header">
          <h5 className="modal-title titulo-modal">{title}</h5>
          <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
            <i onClick={() => toggleModal(false)} className="fas fa-times" style={{ color: '#5E6397' }} />
          </div>
        </div>

        <div className="modal-body">
          <form className="row g-3">
            <div className="col-md-6">
              <label htmlFor="form-item-regra" className="form-label required">Item de regra</label>
              <select {...formik.getFieldProps('regraID')} placeholder="Selecione" className="form-select" id="form-item-regra" onChange={async e => {
                let value = 0;

                if(e.target.value){
                  value = parseInt(e.target.value);
                }

                await formik.setFieldValue('regraID', value)
              }}>
                <option value="" hidden>Selecione</option>
                {
                  regras?.map((x, index) => <option key={index} value={x.id}>{x.nome}</option>)
                }
              </select>
            </div>
            <div className="col-md-6">
              <label htmlFor="form-tipo-mensagem" className="form-label required">Tipo de mensagem</label>
              <select {...formik.getFieldProps('tipoMensagemID')} placeholder="Selecione" className="form-select" id="form-tipo-mensagem" onChange={async e => {

                let value = 0;

                if(e.target.value){
                  value = parseInt(e.target.value);
                }

                await formik.setFieldValue('tipoMensagemID', value)}
                }
                >
                <option value="" hidden>Selecione</option>
                {
                  tipoMensagens?.map((x, index) => <option key={index} value={x.id}>{x.nome}</option>)
                }
              </select>
            </div>
            <div className="col-md-12">
              <label htmlFor="form-descricao-regra" className="form-label required">Descrição da regra de negócio</label>
              <input {...formik.getFieldProps('descricaoRegraNegocio')} placeholder="Digite algo" type="text" className={clsx(
                'form-control',
                {
                  'is-invalid': formik.touched.descricaoRegraNegocio && formik.errors.descricaoRegraNegocio
                },
                {
                  'is-valid': formik.touched.descricaoRegraNegocio && !formik.errors.descricaoRegraNegocio
                }
              )} id="form-descricao-regra" />
            </div>
            <div className="col-md-12">
              <label htmlFor="form-divergencia" className="form-label required">Divergência</label>
              <input {...formik.getFieldProps('divergencia')} placeholder="Digite algo" type="text" className={clsx(
                'form-control',
                {
                  'is-invalid': formik.touched.divergencia && formik.errors.divergencia
                },
                {
                  'is-valid': formik.touched.divergencia && !formik.errors.divergencia
                }
              )} id="form-divergencia" />
            </div>
            <div className="col-md-12">
              <label htmlFor="form-descricaoMensagem" className="form-label required">Descrição da mensagem</label>
              <input {...formik.getFieldProps('descricaoMensagem')} placeholder="Digite algo" type="text" className={clsx(
                'form-control',
                {
                  'is-invalid': formik.touched.descricaoMensagem && formik.errors.descricaoMensagem
                },
                {
                  'is-valid': formik.touched.descricaoMensagem && !formik.errors.descricaoMensagem
                }
              )} id="form-descricaoMensagem" />
            </div>
            <div className="col-md-12">
              <label htmlFor="form-recomendacaoAjuste" className="form-label required">Recomendação de ajuste</label>
              <input {...formik.getFieldProps('recomendacaoAjuste')} placeholder="Digite algo" type="text" className={clsx(
                'form-control',
                {
                  'is-invalid': formik.touched.recomendacaoAjuste && formik.errors.recomendacaoAjuste
                },
                {
                  'is-valid': formik.touched.recomendacaoAjuste && !formik.errors.recomendacaoAjuste
                }
              )} id="form-recomendacaoAjuste" />
            </div>
            <div className="col-md-4">
              <label htmlFor="form-simboloID" className="form-label required mt-5">Símbolo</label>
              <select {...formik.getFieldProps('simboloID')} id="form-simboloID" className="form-select" onChange={async e => await formik.setFieldValue('simboloID', e.target.value)}>
                <option value="" hidden>Selecione</option>
                {
                  listaSimbolos.length > 0 && listaSimbolos.map((x, index) => <option key={index} value={x.id}>{x.descricao}</option>)
                }
              </select>
            </div>
          </form>
        </div>

        <div className="modal-footer" style={{ margin: '0 auto' }}>
          <button disabled={formik.isSubmitting} onClick={() => toggleModal(false)} type="button" className="btn btn-modal-cancelar me-5"> CANCELAR </button>
          <button disabled={formik.isSubmitting || !formik.isValid} onClick={async () => await formik.submitForm()} type="button" className="btn btn-primario ms-5">
            {!formik.isSubmitting && ((mensagem?.id ?? 0) === 0 ? 'ADICIONAR' : 'EDITAR')}
            {
              formik.isSubmitting && (
                <span className='indicator-progress' style={{ display: 'block' }}>
                  Salvando...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
          </button>
        </div>
      </div>
    </Modal>
  </>
}

export default MensagensModal;